import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const BroadbandSpeedIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 50,
  height = 50,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <circle cx="25.1" cy="40.3" fill="#E81C30" className={styles.accentColor} r="3.7" />
      <path
        d="M34.2 34.8c-.4 0-.9-.1-1.2-.5-8-6.9-16-.3-16.4 0-.8.7-2 .6-2.6-.2-.7-.8-.6-2 .2-2.6 3.7-3.1 12.9-7.2 21.3 0 .8.7.9 1.9.2 2.6-.4.4-1 .7-1.5.7zM41.8 26.2c-.4 0-.7-.1-1-.3-17.5-11.4-30.6-.6-31.1-.1-.8.7-2 .6-2.6-.2-.7-.8-.6-2 .2-2.6.1-.2 15.7-13.3 35.6-.3.9.6 1.1 1.7.5 2.6-.4.6-1 .9-1.6.9z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
      <path
        d="M46.8 17.3c-.3 0-.7-.1-1-.3-23.1-14.9-40.9-.3-41.1-.1-.8.7-2 .6-2.6-.2-.7-.8-.6-2 .2-2.6.2-.2 20.1-16.5 45.5-.1.9.6 1.1 1.7.6 2.6-.4.4-1 .7-1.6.7z"
        fill="none"
        stroke="#000000"
        className={styles.defaultStrokeColor}
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </Icon>
  )
}
